import React, { useEffect, useState } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import { CustomWidthTooltip } from '../utils/customWidthToolTipUtil';
import { toast } from 'react-toastify';

const PageHeader = ( {title} ) => {

  const [loading, setLoading] = useState(true);
  const [toolTip, setToolTip] = useState([]);

  const getToolTipByName = async (page) => {
    try {
        const res = await fetch(`${process.env.REACT_APP_API}/tooltips/page/${page}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });

        if (!res.ok) throw new Error(`Failed to fetch tooltips: ${res.status}`);
        
        const data = await res.json();

        if (data.data && data.data[0].description !== undefined ) {
          setToolTip(data.data[0].description);
        } else {  
          setToolTip('');
        }        
    } catch (err) {
        toast.error("Error retrieving page description from database : ", err);
    } finally {
        setLoading(false);
    }

  }

  useEffect(() => {
    let page = window.location.pathname.slice(1);
    if (page == undefined) {
      setToolTip(null);
      setLoading(false);
    } else {
      if (page.includes("/")) {
        const index = page.indexOf("/");
        // page = page.slice(0, index) + "%2F" + page.slice(index+1);
        page = page.slice(0, index);
      }
      getToolTipByName(page);
    }
  }, []);



  if (!loading) {
    return (
      <Box sx={{ mb: 2 }}>
        <Typography
          variant="subtitle1"
          component="h1"
          sx={{ fontWeight: 500, color: '#C8C3BC', mb: 1, display:'flex', flexDirection:'row', alignItems:'center' }}
        >
          {title}
          { toolTip !== '' &&
              <CustomWidthTooltip title={<span style={{ whiteSpace: 'pre-line', backgroundColor: 'black' }}>{toolTip}</span>} placement="right-end" dynamicWidth="750px" showPhen="true" />
          }
          
        </Typography>
        <Divider sx={{ width:'100%', color:'grey', borderTop: 1 }} />
      </Box>
    )
  }
}

export default PageHeader;
